import { reactive,ref} from 'vue';
import { defineStore } from 'pinia'
import { useApiCall } from '@/components/composables/api'; 
import { useCompanyStore } from '@/stores/company'

const initState = ()=>{
    return {
        uid  :"",
        utkn  :"",
        name  :"",
        avatar  :"",
        is_verified:false,
        permissions:[],
        user_code:""
        
   }
}

export const useUserStore = defineStore('user', () => {
    const api = useApiCall()
    const user = reactive(initState())
    const storeCompany = useCompanyStore()

    const whereiwas = reactive({
        fullpath:"",
        query:{},
        params:{}
    })
    const setUserToekn =  (value) => {
        user.utkn = value
    }
    const setWhereiwas =  (value) => {
        whereiwas.fullpath = value.fullpath
        whereiwas.query = value.query
        whereiwas.params = value.params
    }
    const setUserProfile =  (value) => {
        user.uid = value.id
        user.name = value.name.length>0?value.name : value.nickname
        user.avatar = value.avatar
        user.is_verified = value.is_verified
        user.permissions = value.permissions === undefined? []: value.permissions
        user.user_code = value.user_code

    }
    
    const getMyProfile = async () => {
        try {
            let data =  await api.getApi("me/profile/simple") 
             if(data.status){

                setUserProfile(data.user)
                return true
            }else{
                return false
            }
        
        } catch (error) {
            console.log("user store getMyProfile error:",error)
            return false
        }
    }
    const getFullProfile = async () => {
        try {
            let data =  await api.getApi("me/profile/full") 
             if(data.status){
                return data.user
            }else{
                return null
            }
        
        } catch (error) {
            console.log("user store getFullProfile error:",error)
            return null
        }
    }
    const checkLoggedIn = async () => {
        try {
            let data =  await api.getApi("me/checkLoggedIn") 
             if(data.status){
                return data.result
            }else{
                return false
            }
        
        } catch (error) {
            console.log("user store checkLoggedIn error:",error)
            return false
        }
    }
    const logout =  () => {
        Object.assign(user,initState())
    }
    function canAction(permit_list){

        for(let i =0 ; i< permit_list.length;i++){
            let permit = permit_list[i]
            
            let company_id = storeCompany.selected_company.id
            let data_id = "none"
            let permit_name = permit.replace('#',company_id).replace('@',data_id)
            if(user.permissions.indexOf(permit_name)>=0){
                return true
            }
        }
        return false
        
    }
    function canAnyAction(permit_list){
       
        let tmp_permits = user.permissions.map((x)=>{
            let ls = x.split('.')
            return `${ls[0]}.${ls[2]}`
        })
        for(let i =0 ; i< permit_list.length;i++){
            let permit = permit_list[i]
            let permit_name = permit.replace('.#.','.').replace('.@.','.')
            if(tmp_permits.indexOf(permit_name)>=0){
                return true
            }
        }
        return false
        
    }
    return { user,whereiwas,
        
        getMyProfile,getFullProfile,checkLoggedIn,
        setUserToekn,
        setUserProfile,setWhereiwas,
        logout,
        canAction,canAnyAction}
        
},{ persist: true})
